import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import StudentService from '../../services/studentServices';
import { clearAuth } from 'store/auth';

export const getBirthdayStudent = createAsyncThunk('student/getBirthdayStudent', async ({ query }, thunkAPI) => {
    try {
      const response = await StudentService.getBirthdayStudent(query);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        thunkAPI.dispatch(clearAuth()); 
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
});

export const exportBirthdayStudent = createAsyncThunk('student/exportBirthdayStudent', async ({ query }, thunkAPI) => {
    try {
      const response = await StudentService.exportBirthdayStudent(query);
      return response;
    } catch (error) {
      if (error?.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
});
  
const initialState = { isLoading: false, list: [], data: [], error: [] };   

const birthdaySlice = createSlice({
    name: 'birthday',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getBirthdayStudent.pending, (state) => {
            state.isLoading = true;
        }),
        builder.addCase(getBirthdayStudent.fulfilled, (state, action) => {
            state.isLoading = false;
            state.list = action.payload;
        }),
        builder.addCase(getBirthdayStudent.rejected, (state) => {
            state.isLoading = false;
        })
        builder.addCase(exportBirthdayStudent.pending, (state) => {
            state.isLoading = true;
        }),
        builder.addCase(exportBirthdayStudent.fulfilled, (state) => {
            state.isLoading = false;
        }),
        builder.addCase(exportBirthdayStudent.rejected, (state) => {
            state.isLoading = false;
        })
    }
})

const { reducer } = birthdaySlice;
export default reducer;